import React from 'react';
import PropTypes from 'prop-types';
import AsyncPlanPickerProvider from './AsyncPlanPickerProvider';
import SyncPlanPickerProvider from './SyncPlanPickerProvider';

/**
 * @param {PlanPickerProviderProps} props
 */
function PlanPickerProvider(props) {
    if (props.dataStrategy === 'async') {
        return <AsyncPlanPickerProvider {...props} />;
    } else {
        return <SyncPlanPickerProvider {...props} />;
    }
}

PlanPickerProvider.propTypes = {
    dataStrategy: PropTypes.oneOf(['async', 'sync'])
};

export default PlanPickerProvider;

/**
 * @typedef {import('./AsyncPlanPickerProvider').AsyncPlanPickerProviderProps | import('./SyncPlanPickerProvider').SyncPlanPickerProviderProps} PlanPickerProviderProps
 */
